import React from 'react'
import ReactDOM from 'react-dom/client'
import { NewsProvider } from './modules/Contexts/NewsProvider';
import { addLocale, PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import NewsApp from './modules/News/news';

const daLocale = {
    firstDayOfWeek: 1,
    dayNames: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"],
    dayNamesShort: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
    dayNamesMin: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
    monthNames: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"],
    monthNamesShort: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
    today: 'I dag',
    clear: 'Ryd',
    weekHeader: 'Uge',
    dateFormat: 'dd.mm.yy',
    weak: 'Svag',
    medium: 'Medium',
    strong: 'Stærk',
    accept: 'Accepter',
    reject: 'Afvis',
    choose: 'Vælg',
    upload: 'Upload',
    cancel: 'Annuller',
    addRule: 'Tilføj regel',
    am: 'AM',
    pm: 'PM',
    apply: 'Anvend',
    chooseDate: 'Vælg dato',
    chooseMonth: 'Vælg måned',
    chooseYear: 'Vælg år',
    close: 'Luk',
    contains: 'Indeholder',
    startsWith: 'Starter med'
};

addLocale('da', daLocale);

ReactDOM.createRoot(document.getElementById('react-news')!).render(
    <React.StrictMode>
        <PrimeReactProvider value={{
            locale: 'da',
            ripple: true
        }}>
            <NewsProvider>
                <NewsApp />
            </NewsProvider>
        </PrimeReactProvider>
    </React.StrictMode>,
)